<template>
  <v-dialog
    content-class="alert"
    v-if="getDialog.notify"
    v-model="getDialog.notify"
    activator="parent"
    width="auto"
  >
  <div class="alert-common modal-content" >
    <div class="modal-header">
      <h5 class="modal-title">{{ getNotifyData?.title }}</h5>
      <button
        type="button"
        class="btn-close"
        @click="closeDialog()"
      ></button>
    </div>
    <div class="message-area modal-body">
      <p class="alert-message">
        <span v-html="subTitleParsing"></span>
      </p>
    </div>
    <div class="message-button" v-if="isConfirm">
      <v-btn @click="closeDialog()">{{ $t("button.cancel") }}</v-btn>
      <v-btn class="accent" @click="returnResult">{{ getNotifyData?.btnText }}</v-btn>
    </div>
    <div class="message-button" v-else>
      <v-btn class="accent" @click="closeDialog()">{{
        getNotifyData?.btnText
      }}</v-btn>
    </div>
  </div>
      </v-dialog>
</template>
<script>
import DialogMixin from "@/mixins/dialogMixin";

export default {
  mixins: [DialogMixin],
  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    subTitleParsing() {
      const result = this.getNotifyData?.text.replaceAll("\n", "<br />");
      return result;
    },
  },

  methods: {
    // 모달 닫기 이벤트 emit
    closeDialog() {
      this.setDialog("notify", false);
      // this.$emit("closeDialog", changed);
    },
    // confirm alert 창 시 confirm 후의 액션 method
    returnResult() {
      this.setNotifyData({
        title: "",
        text: "",
        btnText: "",
        isConfirm: false,
      });
      this.$emit("returnResult");
    },
  },
};
</script>
